import { storeName } from './config';

const getStateStore = state => state[storeName] || {};
const getData = state => getStateStore(state).data || {};
const getRtsData = state => getStateStore(state).rtsData || [];

const getStores = state => getData(state).stores || getData(state).results || [];
const getStoreLetterList = state => getStateStore(state).storeLetterList || [];
const getRtsStores = state => getRtsData(state).stores || [];
const getQueryRequiredValue = state => getStateStore(state).queryRequired || false;
const getStoreByIndex = (state, index) => getStores(state)[index] || {};
const getRtsStoreByIndex = (state, index) => getRtsStores(state)[index] || {};
const getSelectedStore = state => getStateStore(state).selectedStore;
const getStoreSelectionId = state => getStateStore(state).storeSelectionId;
const hasError = state => getStateStore(state).error;
const getErrorType = state => getStateStore(state).errorType;
const isGoogleMapsApiLoaded = state => getStateStore(state).googleMapsApiLoaded;
const isLocationTextPresent = state => !!getData(state).locationText;
const getSourceLatitude = state => getData(state).sourceLatitude; // can be 0
const isFilteredData = state => isLocationTextPresent(state) || getSourceLatitude(state);

const getApiParameters = state => getStateStore(state).apiParameters || {};
const getQueryApiParameter = state => getApiParameters(state).query || '';

const getCalculatedPagination = state => getStateStore(state).pagination || {};
const getPaginatedStores = state => getCalculatedPagination(state).stores || getStores(state);

const getPagination = state => getData(state).pagination || {};

export default {
    getData,
    getStores,
    getStoreLetterList,
    getRtsStores,
    getRtsStoreByIndex,
    getQueryRequiredValue,
    getSelectedStore,
    getStoreSelectionId,
    hasError,
    isGoogleMapsApiLoaded,
    isFilteredData,
    getApiParameters,
    getStoreByIndex,
    getPaginatedStores,
    isLocationTextPresent,
    getQueryApiParameter,
    getPagination,
    getErrorType,
};
